import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { SpeedDialComponent } from './speed-dial/speed-dial.component';
import { CustomSearchComponent } from './custom-search/custom-search.component';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [
    // SearchComponent,
    SpeedDialComponent,
    CustomSearchComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatChipsModule,
    MatDialogModule
  ],
  exports: [
    // SearchComponent,
    SpeedDialComponent,
    CustomSearchComponent
  ]
})
export class ComponentsModule { }
